import {
  Icon,
  LinkButton,
  Stack,
  Text,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@eluve/components';
import { formatDate } from '@eluve/date-utils';
import { useTranslation } from '@eluve/i18n';
import { FeatureFlaggedComponent } from '@eluve/smart-blocks';

import { AppointmentEmailSuperbillDialog } from './AppointmentEmailSuperbillDialog';

type SuperbillCardProps = {
  createdAt: string;
  downloadUrl: string;
};

export const SuperbillCard = ({
  createdAt,
  downloadUrl,
}: SuperbillCardProps) => {
  const { t } = useTranslation();
  return (
    <Stack gap={4} direction="horizontal">
      <Stack
        className="size-11 shrink-0 rounded-lg bg-border-primary"
        align="center"
        justify="center"
        gap={2}
      >
        <Icon name="FileText" size="lg" />
      </Stack>
      <Stack>
        <Text inline weight="semibold">
          {t('appointmentPage.superbill.title')}
        </Text>
        <Text inline size="xs" color="secondary">
          {formatDate.toDisplay(createdAt)}
        </Text>
      </Stack>
      <Stack justify="end" gap={2} direction="horizontal">
        <FeatureFlaggedComponent flag="ENABLE_SUPERBILL_EMAIL">
          <AppointmentEmailSuperbillDialog />
        </FeatureFlaggedComponent>
        <Tooltip>
          <TooltipTrigger asChild>
            <LinkButton variant="outline" size="sm" href={downloadUrl}>
              <Icon name="Eye" size="auto" />
            </LinkButton>
          </TooltipTrigger>
          <TooltipContent align="end" alignOffset={-8}>
            {t('appointmentPage.superbill.viewPdf')}
          </TooltipContent>
        </Tooltip>
      </Stack>
    </Stack>
  );
};
